module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/6-bac23fe1380200101e6b6f25aacaf4f5.jpg";